module.exports = __webpack_public_path__ + "img/relive-button.cbe32d30.svg";